import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { RunTestOutcome } from '@/types/runTestOutcome.ts';
import { RUN_TEST_OUTCOME_KEY } from '@/utils/queryKeys.ts';
import { get_run_test_outcome_url } from '@/utils/urls.ts';

const useRetrieveRunTestOutcome = (
  runId?: string,
  enabled = true,
): UseQueryResult<RunTestOutcome, AxiosError> => {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: RUN_TEST_OUTCOME_KEY(runId),
    queryFn: async () =>
      (await apiClient.get<RunTestOutcome>(get_run_test_outcome_url(runId))).data,
    enabled: !!runId && enabled,
  });
};

export default useRetrieveRunTestOutcome;
